import Vue from 'vue';
import 'babel-polyfill';
import VueMessages from 'vue-messages';
import App from './app';
import router from './router';
import store from './store';
import Event from './components/event';
import Validate from './utils/validate';
import './styles/index.styl';
import './styles/theme-1.styl';
import './styles/theme-2.styl';
import './styles/theme-3.styl';
import axios from 'axios';
import MessageBox from "./components/dialog/plugin";
import { getToken, setToken, clearToken } from './utils/authToken';
Vue.use(MessageBox);
axios.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers['Token'] = token;
  }
  if (config.method === 'post') {
    if (!config.headers) config.headers = {};
    if (!config.data) config.data = {};
    let ret = '';
    for (let it in config.data) ret += encodeURIComponent(it) + '=' + encodeURIComponent(config.data[it]) + '&';
    ret = ret.substring(0, ret.lastIndexOf('&'));
    config.data = ret;
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return config;
});
axios.interceptors.response.use(
  res => {
    if(res.config.url.indexOf("/ssc_golang/v1/user/login") > -1 && (res.data.result=='ok' || (res.data.result=='error' && res.data.msg=='请您进行密码更换'))){
      setToken(res.data.data);
    }
    if(res.data.result=='error' && res.data.msg=='用户没有登录'){
      var fromurl = res.config.url
      if (fromurl.indexOf("user/userinfo") <= -1)
      {
       clearToken();
       window.location.reload()
      }
    }
    return res.data
  },
  err => {
    return Promise.reject(err.response.data)
  }
)
//axios.interceptors.response.use(info => info.data);

// 项目路径
axios.defaults.baseURL = '/api/';

Vue.prototype.$store = store;
Vue.prototype.$validate = Validate;
Vue.prototype.$pcurl = 'Global Value';

Vue.use(VueMessages, {
  content: '',
  duration: 2,
  themes: 'blackGold',
  styles: {
    top: '40%',
    position: 'fixed',
    zIndex: 99999,
    fontWeight: 'normal',
    fontSize: '20px',
    //width: '200px',
    height: '50px'
  },
  before() {
  },
  done() {
  }
});


Vue.component('event', Event);
Vue.config.productionTip = false;
Vue.config.devtools = false;

const rAF = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.oRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };

window.requestAnimationFrame = rAF;

// const whiteMap = ['/login'];
//
// router.beforeEach(async (to, from, next) => {
//
//   if (whiteMap.includes(to.path)) return next();
//
//   await store.dispatch('root/getUserInfo');
//
//   if (!store.state.root.user.uid) {
//     const query = 'path=' + to.path;
//     const path = '/login?' + encodeURI(query);
//     next(path);
//   } else {
//     next();
//   }
//
// });


window.vm_app = new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js